(() => {
  const NOTE_CLASS = 'custom-cart-guest-checkout-note';
  const DEFAULT_TEXT = 'No account required — guest checkout available.';

  function addNote(checkoutButton) {
    const checkoutArea = checkoutButton.closest('.cart__ctas, form') || checkoutButton.parentElement;
    if (!checkoutArea || checkoutArea.previousElementSibling?.classList.contains(NOTE_CLASS)) return;

    const note = document.createElement('p');
    note.className = NOTE_CLASS;

    if (checkoutButton.closest('#cart-notification')) {
      note.innerHTML = `
        <span class="custom-cart-guest-checkout-note__mobile">No Account Needed — Checkout as Guest</span>
        <span class="custom-cart-guest-checkout-note__desktop">No Account Needed — Checkout as Guest</span>
      `;
    } else {
      note.textContent = DEFAULT_TEXT;
    }

    checkoutArea.insertAdjacentElement('beforebegin', note);
  }

  function initialize() {
    document
      .querySelectorAll('#checkout, #CartDrawer-Checkout, #cart-notification-form button[name="checkout"]')
      .forEach(addNote);
  }

  initialize();
  new MutationObserver(initialize).observe(document.body, { childList: true, subtree: true });
})();
